import Message from "@shared/services/message";

export const livenessText = () => ({
  errorLabelText: Message.getMessageByKey("liveness.errorLabelText"),
  connectionTimeoutHeaderText: Message.getMessageByKey(
    "liveness.connectionTimeoutHeaderText",
  ),
  connectionTimeoutMessageText: Message.getMessageByKey(
    "liveness.connectionTimeoutMessageText",
  ),
  timeoutHeaderText: Message.getMessageByKey("liveness.timeoutHeaderText"),
  timeoutMessageText: Message.getMessageByKey("liveness.timeoutMessageText"),
  faceDistanceHeaderText: Message.getMessageByKey(
    "liveness.faceDistanceHeaderText",
  ),
  faceDistanceMessageText: Message.getMessageByKey(
    "liveness.faceDistanceMessageText",
  ),
  multipleFacesHeaderText: Message.getMessageByKey(
    "liveness.multipleFacesHeaderText",
  ),
  multipleFacesMessageText: Message.getMessageByKey(
    "liveness.multipleFacesMessageText",
  ),
  clientHeaderText: Message.getMessageByKey("liveness.clientHeaderText"),
  clientMessageText: Message.getMessageByKey("liveness.clientMessageText"),
  serverHeaderText: Message.getMessageByKey("liveness.serverHeaderText"),
  serverMessageText: Message.getMessageByKey("liveness.serverMessageText"),
  landscapeHeaderText: Message.getMessageByKey("liveness.landscapeHeaderText"),
  landscapeMessageText: Message.getMessageByKey(
    "liveness.landscapeMessageText",
  ),
  portraitMessageText: Message.getMessageByKey("liveness.portraitMessageText"),
  tryAgainText: Message.getMessageByKey("liveness.tryAgainText"),
  cameraMinSpecificationsHeadingText: Message.getMessageByKey(
    "liveness.cameraMinSpecificationsHeadingText",
  ),
  cameraMinSpecificationsMessageText: Message.getMessageByKey(
    "liveness.cameraMinSpecificationsMessageText",
  ),
  cameraNotFoundHeadingText: Message.getMessageByKey(
    "liveness.cameraNotFoundHeadingText",
  ),
  cameraNotFoundMessageText: Message.getMessageByKey(
    "liveness.cameraNotFoundMessageText",
  ),
  a11yVideoLabelText: Message.getMessageByKey("liveness.a11yVideoLabelText"),
  cancelLivenessCheckText: Message.getMessageByKey(
    "liveness.cancelLivenessCheckText",
  ),
  goodFitCaptionText: Message.getMessageByKey("liveness.goodFitCaptionText"),
  goodFitAltText: Message.getMessageByKey("liveness.goodFitAltText"),
  hintCenterFaceText: Message.getMessageByKey("liveness.hintCenterFaceText"),
  hintCenterFaceInstructionText: Message.getMessageByKey(
    "liveness.hintCenterFaceInstructionText",
  ),
  hintFaceOffCenterText: Message.getMessageByKey(
    "liveness.hintFaceOffCenterText",
  ),
  hintMoveFaceFrontOfCameraText: Message.getMessageByKey(
    "liveness.hintMoveFaceFrontOfCameraText",
  ),
  hintTooManyFacesText: Message.getMessageByKey(
    "liveness.hintTooManyFacesText",
  ),
  hintFaceDetectedText: Message.getMessageByKey(
    "liveness.hintFaceDetectedText",
  ),
  hintCanNotIdentifyText: Message.getMessageByKey(
    "liveness.hintCanNotIdentifyText",
  ),
  hintTooCloseText: Message.getMessageByKey("liveness.hintTooCloseText"),
  hintTooFarText: Message.getMessageByKey("liveness.hintTooFarText"),
  hintConnectingText: Message.getMessageByKey("liveness.hintConnectingText"),
  hintVerifyingText: Message.getMessageByKey("liveness.hintVerifyingText"),
  hintCheckCompleteText: Message.getMessageByKey(
    "liveness.hintCheckCompleteText",
  ),
  hintIlluminationTooBrightText: Message.getMessageByKey(
    "liveness.hintIlluminationTooBrightText",
  ),
  hintIlluminationTooDarkText: Message.getMessageByKey(
    "liveness.hintIlluminationTooDarkText",
  ),
  hintIlluminationNormalText: Message.getMessageByKey(
    "liveness.hintIlluminationNormalText",
  ),
  hintHoldFaceForFreshnessText: Message.getMessageByKey(
    "liveness.hintHoldFaceForFreshnessText",
  ),
  hintMatchIndicatorText: Message.getMessageByKey(
    "liveness.hintMatchIndicatorText",
  ),
  photosensitivityWarningBodyText: Message.getMessageByKey(
    "liveness.photosensitivityWarningBodyText",
  ),
  photosensitivityWarningHeadingText: Message.getMessageByKey(
    "liveness.photosensitivityWarningHeadingText",
  ),
  photosensitivityWarningInfoText: Message.getMessageByKey(
    "liveness.photosensitivityWarningInfoText",
  ),
  photosensitivityWarningLabelText: Message.getMessageByKey(
    "liveness.photosensitivityWarningLabelText",
  ),
  retryCameraPermissionsText: Message.getMessageByKey(
    "liveness.retryCameraPermissionsText",
  ),
  recordingIndicatorText: Message.getMessageByKey(
    "liveness.recordingIndicatorText",
  ),
  startScreenBeginCheckText: Message.getMessageByKey(
    "liveness.startScreenBeginCheckText",
  ),
  tooFarCaptionText: Message.getMessageByKey("liveness.tooFarCaptionText"),
});
